<template>
  <div id="app">
    <div>
       <Header></Header>
       <SerAopi></SerAopi>
        <router-view/>
        <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from './components/header';
import SerAopi  from './components/serveAopinion ';
import Footer from './components/footer';
export default {
  name: 'App',
  data:function(){
    return {
      keepAlive:true,
    }
  },
  components: {
    Header,
    SerAopi,
    Footer,
    
  },
  mounted(){
  }
}
</script>

<style lang="scss">
  @import "./assets/css/app";

</style>



// WEBPACK FOOTER //
// src/App.vue